module.exports = __webpack_public_path__ + "img/icons8-fiat.f04b1870.png";